import { render, staticRenderFns } from "./AwardScopeFields.vue?vue&type=template&id=0ae44e9f&scoped=true&"
import script from "./AwardScopeFields.vue?vue&type=script&lang=js&"
export * from "./AwardScopeFields.vue?vue&type=script&lang=js&"
import style0 from "./AwardScopeFields.vue?vue&type=style&index=0&id=0ae44e9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae44e9f",
  null
  
)

export default component.exports